/** AlertsHistoryRoute — skin-aware switcher for /alerts. */
import { useUISkin } from "@/data/UISkinContext";
import AlertsHistory from "./AlertsHistory";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";

export default function AlertsHistoryRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") {
    return (
      <CockpitFrame eyebrow="Admin · Notifications" title="Alerts History">
        <AlertsHistory />
      </CockpitFrame>
    );
  }
  return <AlertsHistory />;
}
